import { render, staticRenderFns } from "./WelcomeSprite3.vue?vue&type=template&id=0c534b22&scoped=true&lang=pug&"
import script from "./WelcomeSprite3.vue?vue&type=script&lang=js&"
export * from "./WelcomeSprite3.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSprite3.vue?vue&type=style&index=0&id=0c534b22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c534b22",
  null
  
)

export default component.exports